<template>
  <div class="p-4">
    <div class="color-primary mb-2">
      Afin de vous éclairer pour faire votre choix d'assurance complémentaire santé en toute connaissance de cause SwissLife vous permet d'afficher à votre convenance :
    </div>

    <ul>
      <li><b>- soit le tableau des garanties</b>, exprimés en % de remboursement de votre régime obligatoire</li>
      <li><b>- soit des exemples de remboursements</b>, exprimés en euros de votre reste à charge, après remboursement de la SS et de Swiss Life</li>
    </ul>

    Vous pouvez afficher l'un ou l'autre en cliquant sur les boutons « Exemples de remboursements » ou « Tableau de garanties complet ».
  </div>
</template>

<script>
/**
 */
export default {
  name: 'NoticeHelp',
}
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";

.color-primary {
  color: $red;
}

</style>